import { email as emailRegexp } from '@app/constants/regexp';
import { string } from 'yup';

export const email = string()
  .required('${label} cannot be blank.')
  .matches(emailRegexp, 'Email is not a valid email address.')
  .label('Email');
